module.exports = __webpack_public_path__ + "assets/new-dashboard.svg";